// Sounds and knobs, in acid house: every number that sets a parameter has a
// knob beside it. Drag the acid's cutoff and resonance while it plays, the
// gesture of the 303; the capitals are its accents. The 808 kit, the FM bell
// and the organ, with its rotating speaker, each have knobs of their own.
meter: 4/4
tempo: 124

drums: drums.808 -> compressor
drums {
  bd   = b b b b
  oh   = -o -o -o -o
  clap = - p - p
  hh   = cc cc cc cc
}

acid: bass.acid -> drive -> lowpass -> delay
acid = | [a1 A1 a2 a1] [c2 a1 A2 a1] [e2 a1 g2 a1] [A1 c2 a1 e2] |
acid {
  lowpass.cutoff = 900 Hz
  lowpass.resonance = 0.75
  drive.amount = 12 dB
  delay.sync = 0.75
  delay.mix = 0.15
}

bell: keys.bell -> delay -> reverb
bell = | e5 _ _ _ | - - c5 _ | d5 _ _ _ | - - a4 _ |
bell {
  volume = 0.45
  delay.sync = 0.75
  delay.mix = 0.35
  reverb.mix = 0.5
}

hammond: keys.organ -> reverb
hammond = | - [- a3+c4+e4] - [- a3+c4+e4] |
hammond.organ.rotary = 2
hammond.volume = 0.35
